/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ShowTrussRunsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-919)">
      <g id="Show-Truss-Runs" transform="matrix(0.542569,0,0,0.571048,169.854,377.677)">
        <g transform="matrix(0.632127,-2.57388e-16,-1.00628e-16,0.600602,-1525.62,947.962)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(-6.40228e-18,-0.0446438,-0.101313,0.000139028,140.228,1057.63)">
          <path
            d="M1664.82,751.754L1664.81,884.876L1775.07,834.167L1774.66,701.237L1664.82,751.754Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(-6.40228e-18,-0.0446438,-0.101313,0.000139028,126.867,1057.63)">
          <path
            d="M1664.82,751.754L1664.81,884.876L1775.07,834.167L1774.66,701.237L1664.82,751.754Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(-1.22448e-17,0.0446438,0.101313,-0.000139028,-14.8528,919.65)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0333293,-0.0314617,-0.0612803,0.0587988,167.676,983.686)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-0.0333293,-0.0314617,-0.0612803,0.0587988,154.315,983.686)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0333293,-0.0314617,0.0191194,0.0183452,6.40282,1005.3)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0333293,-0.0314617,0.0191194,0.0183452,-6.95822,1005.3)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(-1.25725e-17,0.0446438,0.0417017,-5.72258e-05,76.3468,919.594)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.256162,2.02459e-32,-5.56763e-32,0.256514,-335.882,759.983)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0476336,9.60342e-18,-5.04067e-05,0.0367325,-42.0394,970.51)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0476336,3.20114e-18,-5.04067e-05,0.0367325,29.9191,970.517)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0476336,3.20114e-18,-5.04067e-05,0.0367325,-14.2284,970.517)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0476336,3.20114e-18,-5.04067e-05,0.0367325,-27.6949,970.517)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(6.40228e-18,-0.0446438,0.101313,0.000139028,24.7957,1057.63)">
          <path
            d="M1664.82,751.754L1664.81,884.876L1775.07,834.167L1774.66,701.237L1664.82,751.754Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(-6.40228e-18,-0.0446438,-0.101313,0.000139028,153.705,1057.63)">
          <path
            d="M1664.03,498.791L1664.81,884.876L1775.07,834.167L1773.87,448.274L1664.03,498.791Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(-0.0333293,-0.0314617,-0.0612803,0.0587988,181.142,983.686)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
        <g transform="matrix(0.0333293,-0.0314617,0.0612803,0.0587988,-2.65242,983.686)">
          <rect x="1664.82" y="534.186" width="110.252" height="352.189" style={{ fill: 'white' }} />
        </g>
      </g>
    </g>
  </svg>,
  'ShowTrussRunsIcon',
);
